import { IconProps } from "../../utils/global-types/global-types";

const ShareIcon = ({ className, ...rest }: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 18 18"
    className={className ? className : "w-[18px] h-[18px]"}
    {...rest}
  >
    <g fill="currentColor" clipPath="url(#clip0_25037_218094)">
      <path d="m15.878 6.071-3.792-3.937a.438.438 0 0 0-.753.304v1.895h-.146A5.694 5.694 0 0 0 5.5 10.021v.875a.43.43 0 0 0 .437.43.45.45 0 0 0 .4-.25 4.79 4.79 0 0 1 4.303-2.66h.693v1.896a.437.437 0 0 0 .753.304l3.791-3.938a.44.44 0 0 0 0-.607"></path>
      <path d="M14.25 16H3.75C2.785 16 2 15.215 2 14.25V6.083c0-.964.785-1.75 1.75-1.75H5.5a.583.583 0 1 1 0 1.167H3.75a.584.584 0 0 0-.583.583v8.167c0 .322.261.583.583.583h10.5a.584.584 0 0 0 .583-.583V9.583a.583.583 0 1 1 1.167 0v4.667c0 .965-.785 1.75-1.75 1.75"></path>
    </g>
    <defs>
      <clipPath id="clip0_25037_218094">
        <path fill="#fff" d="M2 2h14v14H2z"></path>
      </clipPath>
    </defs>
  </svg>
);

export default ShareIcon;
